import { UserInfoForm } from './UserInfoForm'
import { UserInfoContainer } from './UserInfoStyled'
import React from 'react'
import { IdentityVerification } from '../IdentityVerification'
import { Spacer } from '@spritz-finance/ui'

export const UserInfo = () => {
    return (
        <UserInfoContainer>
            <IdentityVerification />
            <Spacer height={32} />
            <UserInfoForm />
        </UserInfoContainer>
    )
}
